"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var _excluded = ["size"];

var _this = void 0;

/**
 * ChargeInfo.Divider
 * @description 计费UI组件-分割线
 */
var Divider = function Divider(_ref) {
  (0, _newArrowCheck2["default"])(this, _this);
  var size = _ref.size,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_style.StyledDivider, (0, _extends2["default"])({
    size: size
  }, others));
}.bind(void 0);

Divider.propTypes = {
  /** 分割线的尺寸 */
  size: _propTypes["default"].oneOf(["sm", "md", "lg"])
};
Divider.defaultProps = {
  size: "lg"
};
var _default = Divider;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ChargeInfo/Divider.js
// module id = 1785
// module chunks = 6 7 17 18